export const DefaultTranslatedMessageNamespace = 'DefaultMessage';
export default {
  [DefaultTranslatedMessageNamespace]: {
    title: "There's nothing to see here yet",
    message: '',
  },
};
